import { createContext } from 'react-router';

import type { CartResult } from '@/shared/types/fetch.types';

export type CartContextValue =
  { status: 'ok'; cart: CartResult } | { status: 'error'; error: unknown };

export const cartContext = createContext<Promise<CartContextValue>>();
